export default __webpack_public_path__ + "static/media/cake14.f6ba2c29.jpeg";